import { GET_DRIVERS_BALANCE_API, GET_FLEET_BALANCE_API } from "../utils/api";
import { handleError } from "../utils/errorUtils";

export const LOAD_DRIVERS_BALANCE_REQUEST =
  "@balance/LOAD_DRIVERS_BALANCE_REQUEST";
export const LOAD_FLEET_BALANCE_REQUEST = "@balance/LOAD_FLEET_BALANCE_REQUEST";
export const RESET_TRIP_REQUEST = "@balance/RESET_TRIP_REQUEST";
export type DRIVERS_BALANCE_REQUEST = typeof LOAD_DRIVERS_BALANCE_REQUEST;
export type FLEET_BALANCE_REQUEST = typeof LOAD_FLEET_BALANCE_REQUEST;

interface IDriversBalance {
  data: any;
  total: number;
}

export interface LoadDriversBalance {
  type: DRIVERS_BALANCE_REQUEST;
  payload: {
    drivers: IDriversBalance | null;
    error: string | null;
  };
}

export interface LoadFleetBalance {
  type: FLEET_BALANCE_REQUEST;
  payload: {
    balance: number | null;
    error: string | null;
  };
}

interface IFilters {
  page: number;
  limit: number;
  driver?: string;
}

export async function loadDriversBalance(
  filters: IFilters
): Promise<LoadDriversBalance> {
  try {
    const response = await GET_DRIVERS_BALANCE_API(filters);
    const { pagination, list } = response.data.data;
    return {
      type: LOAD_DRIVERS_BALANCE_REQUEST,
      payload: {
        drivers: {
          data: list,
          total: pagination.total,
        },
        error: null,
      },
    };
  } catch (error) {
    const errorMessage = handleError(error);
    return {
      type: LOAD_DRIVERS_BALANCE_REQUEST,
      payload: {
        drivers: null,
        error: errorMessage,
      },
    };
  }
}

export async function loadFleetBalance(): Promise<LoadFleetBalance> {
  try {
    const response = await GET_FLEET_BALANCE_API();
    const { totalBalance } = response.data.data;
    return {
      type: LOAD_FLEET_BALANCE_REQUEST,
      payload: {
        balance: totalBalance ?? 0,
        error: null,
      },
    };
  } catch (error) {
    const errorMessage = handleError(error);
    return {
      type: LOAD_FLEET_BALANCE_REQUEST,
      payload: {
        balance: null,
        error: errorMessage,
      },
    };
  }
}
